import React, { Component } from 'react';
import pic1 from '../images/about_pic_mess1.jpg';
import pic2 from '../images/about_pic_mess2.jpg';
import pic3 from '../images/about_pic_mess3.jpg';
import pic4 from '../images/about_pic_mess4.jpg';
import pic5 from '../images/about_pic_mess5.jpg';
import pic6 from '../images/about_pic_mess6.jpg';
import pic7 from '../images/about_pic_mess7.jpg';
import pic8 from '../images/about_pic_mess8.jpg';
import pic9 from '../images/about_pic_mess9.jpg';
import pic01 from '../images/about_pic_mess01.jpg';
import pic02 from '../images/about_pic_mess02.jpg';
import pic03 from '../images/about_pic_mess03.jpg';
import pic04 from '../images/about_pic_mess04.jpg';
import pic05 from '../images/about_pic_mess05.jpg';
import pic06 from '../images/about_pic_mess06.jpg';

export default class About extends Component {
    render() {
        return (
            <div className="container mt-5 pt-5">
                <div className="">
                    <div className="mt-2 pt-5" id="about-img"></div>
                    <br></br>
                    <h3>About us</h3><br/>
                    <p>Fredrick Agbaje Foundation; an NGO that focuses on education and empowering rural school kids</p>
                    <p>
                    The Fredrick Ovie Agbaje Foundation is dedicated to giving rural kids age 10 to 16 years opportunity and support to stay in school. The foundation strives to accomplish this goal through promotion of Athletics, provision of school supplies and training kits, equipments mentorship and incresed access to some of the best colleges in the world.
                    </p>                   
                </div><br/>
                {/*Mission*/}
                <div className="mt-2 pt-2">
                    <h3>Our Aim</h3>
                    <div className="grid1">
                        <div className="grid1__item">
                            <span class="grid1__icon"><i class="fas fa-university"></i></span>
                            <h4>EDUCATION</h4>
                            <p>Since the begining, the foundation has made 100% effort directly to improve the quality of education of the beneficiaries.</p>
                        </div>
                        <div className="grid1__item">
                            <span class="grid1__icon"><i class="fas fa-running"></i></span>
                            <h4>ATHLETICS</h4>
                            <p>We are focusing on track and field as an educational tool, that will help us to empower rural school kids to the best of there ability.</p>
                        </div>
                        <div className="grid1__item">
                            <span class="grid1__icon"><i class="fas fa-toolbox"></i></span>
                            <h4>INFRASTRUCTURE</h4>
                            <p>In the next few years, we look forward to infrastructure growth. This will ensure that we meet the educational and athletics training needs of these youngsters throughout their teenage years</p>
                        </div>
                    </div>
                </div><br/>
                {/*News*/}
                <div className="mt-2 pt-2">
                    <h3>What others say about us</h3>
                    <div className="grid">
                        <div className="grid__item">
                            <a href="https://saveoursports.ng/our-sponsors/fredrick-agbaje/" className="about_grid_img1">
                            </a>
                            <h6>Save Our Sport</h6>
                        </div>
                            <div className="grid__item">
                            <a href="https://www.vanguardngr.com/2014/03/rural-kids-want-agbaje-athletics-foundation/" className="about_grid_img2">
                            </a>
                            <h6>Rural kids want more</h6>
                        </div>
                        <div className="grid__item">
                            <a href="https://dickinsonstate.tumblr.com/post/156635701842/agbaje-pursues-his-dream-by-helping-others-pursue" className="about_grid_img3">
                            </a>
                            <h6>Pursuing dreams</h6>
                        </div>
                    </div>
                </div>
                <div className="mt-2 pt-2">
                    <br></br>
                    <h3>Meet the founder</h3><br/>
                    <p>
                    Fredrick Ovie Agbaje Global Foundation was founded by Fredrick Ovie Agbaje in 2013 and was formally registered in 2020.
                    He was born and raised in a rustic town of Ososo in Akoko-Edo Local Government of Edo State, South-South, Nigeria. 
                    As a young school boy, he developed a great passion for sports generally.
                    However, his avid interest in sports could not be harnessed due to lack of opportunities and role models.
                    His illiterate parents who were of modest means could not also do much for their young son as they emphasized more on his educational advancement at least beyond the First School Leaving Certificate. His interest in sport was tamed and limited.
                    Young Fredrick's undying passion for track and field sport was rejuvenated when fate thrust on him a rare opportunity to leave his country side home of Ososo for the City.
                    With no one to look up to, he started sneaking out at dawn for the several miles of daily journey on foot for the stadium.
                    He became a known face around the sport centre and by watching others, his track and field skills were sharpened. 
                    By sheer handwork, consistency and the grace of God, he got a scholarship to further his education in the United States of America. 
                    He was thus offered provisional admission into the prestigious Dickinson State University (DSU) Dickinsom in North Dakota, United States where he remarkably distinguished himself both in academics and his focal area of interest, Track and Field events. Fredrick, now a young adult in a foreign from a tiny village in Nigeria endeared himself to many and was the darling of all sports loving students and teachers.
                    While in the U.S, he remembered where he was coming from and decided to be a role model to the several school kids in the rural areas with passion for sports with no readily available and accessible opportunities. 
                    His vision is to groom these kids by encouraging them to focus on sport while also acquiring a formal education.
                    He is therefore bringing to the village children the ladder he never had for them to climb to the zenith of their dreams in sport and education.
                    </p>                
                </div><br/>
                {/*Pictures*/}
                <div className="mt-2 pt-2">
                    <h3>Picture messages</h3>
                    <div className="grid">
                        <div className="grid__item__pic">
                            <img src={pic1} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic2} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic3} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic4} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic5} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic6} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic7} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic8} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic9} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                        <img src={pic01} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic02} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic03} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                        <img src={pic04} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic05} alt="pic_message" /> 
                        </div>
                        <div className="grid__item__pic">
                            <img src={pic06} alt="pic_message" /> 
                        </div>
                    </div>
                </div>
                {/*Contact*/}
                <div className="about__contact mt-3 pt-3">
                    <h4>Contact Us</h4>
                    <p>Fredrick Agbaje Foundation</p>
                    <p>Tel: </p>
                    <p>Email: </p>
                </div>
            </div>
        )
    }
}
